import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Remove } from '@material-ui/icons';
import Input, { INPUT_TYPES } from '../Input/Input';
import Button from '../Button/Button';
import {
  CHANNELING_CONTEXT_OPTIONS,
  CONTEXT_FIELD_TYPE,
  CONTEXT_VALUE_OPTIONS,
  CONTEXT_GROUPS,
} from '../../constants';

const ChannelContext = props => {
  const {
    channelIndex,
    showVariantType,
    channel,
    updateChannelField,
    contextIndex,
    onInputFieldChange,
    onContextTypeSelect,
    contextType,
  } = props;

  // either inclusions or exclusions
  const contextGroup = channel[showVariantType][contextType];
  const contextGroupPath = `${channelIndex}.${showVariantType}.${contextType}`;
  const contextData = contextGroup[contextIndex];

  // segment, device, login_status etc
  const contextKey = contextData.key;

  // multi_select or free_text or single_select
  const valueFieldType = CONTEXT_FIELD_TYPE[contextKey];

  const isFreeText = valueFieldType === 'free_text';

  // select options either have a fixed list or a dynamic list coming from backend
  // the one coming from props is the backend list
  const selectOptions = (
    CONTEXT_VALUE_OPTIONS[contextKey]
    || props.contextOptions[contextKey]
    || []
  );

  return (
    <li className="flex justify-between mt-2">
      <Select
        isClearable
        isSearchable
        menuPlacement="top"
        options={CHANNELING_CONTEXT_OPTIONS}
        classNamePrefix="context_select"
        className="context_select w-full mr-2"
        value={props.getSingleSelectValue(
          CHANNELING_CONTEXT_OPTIONS,
          contextData.key
        )}
        onChange={valueObject =>
          onContextTypeSelect(
            valueObject ? valueObject.value : '',
            `${contextGroupPath}.${contextIndex}`,
            channelIndex
          )
        }
      />
      {isFreeText ? (
        <Input
          id={`${channelIndex}.name`}
          name={`${contextGroupPath}.${contextIndex}.value`}
          type={INPUT_TYPES.TEXT}
          value={contextData.value || ''}
          onChange={event => onInputFieldChange(event, channelIndex)}
          className="ml-2 w-full"
        />
      ) : (
        <Select
          isClearable
          isSearchable
          isMulti
          menuPlacement="top"
          options={selectOptions}
          classNamePrefix="context_select"
          className="context_select w-full ml-2"
          value={props.getMultiSelectValue(
            selectOptions,
            contextData.value
          )}
          onChange={value =>
            updateChannelField(
              value.map(o => o.value),
              `${contextGroupPath}.${contextIndex}.value`,
              channelIndex
            )
          }
        />
      )}
      <Button
        onClick={() =>
          props.removeContext(channelIndex, contextIndex, contextType)
        }
        type="transparent"
        className="p-0-important shadow-none-important ml-4">
        <Remove className="bg-white text-red rounded-full" />
      </Button>
    </li>
  );
};

ChannelContext.propTypes = {
  channelIndex: PropTypes.number.isRequired,
  contextIndex: PropTypes.number.isRequired,
  showVariantType: PropTypes.string.isRequired,
  channel: PropTypes.object.isRequired,
  updateChannelField: PropTypes.func.isRequired,
  onInputFieldChange: PropTypes.func.isRequired,
  removeContext: PropTypes.func.isRequired,
  contextType: PropTypes.oneOf([
    CONTEXT_GROUPS.INCLUDE,
    CONTEXT_GROUPS.EXCLUDE,
  ]),
};

export default  ChannelContext;
